export default __webpack_public_path__ + "static/media/words.66416631.png";